var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37259 0 0 5.37258 0 12C0 18.6274 5.37259 24 12 24Z",
    fill: "#5A99EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58224 18.9157C15.4489 18.9157 18.6489 14.0623 18.6489 9.84901C18.6489 9.70679 18.6489 9.58235 18.6311 9.44012C19.2534 8.99568 19.7867 8.42679 20.2134 7.78679C19.6445 8.03568 19.0222 8.21346 18.3822 8.28457C19.04 7.89346 19.5378 7.27124 19.7867 6.52457C19.1645 6.8979 18.4889 7.14679 17.76 7.30679C17.1733 6.68457 16.3556 6.29346 15.4311 6.29346C13.6711 6.29346 12.2489 7.71568 12.2489 9.47568C12.2489 9.72457 12.2845 9.97345 12.3378 10.2046C9.6889 10.0801 7.34224 8.80012 5.7778 6.88012C5.51113 7.34235 5.35114 7.89346 5.35114 8.48012C5.35114 9.58235 5.92003 10.5601 6.77336 11.129C6.25781 11.1112 5.76002 10.969 5.33336 10.7379C5.33336 10.7557 5.33336 10.7557 5.33336 10.7735C5.33336 12.3201 6.43557 13.6001 7.89335 13.9023C7.62668 13.9735 7.34225 14.009 7.0578 14.009C6.84447 14.009 6.64891 13.9912 6.45335 13.9557C6.86224 15.2179 8.03559 16.1423 9.42226 16.1601C8.33781 17.0135 6.95113 17.529 5.4578 17.529C5.20891 17.529 4.94225 17.5112 4.69336 17.4935C6.0978 18.4001 7.78668 18.9157 9.58224 18.9157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.fc2b29566817e6efc4a349de66e54f46.svg";
export { ForwardRef as ReactComponent };